import type { LeagueSummary } from "@softmax/observatory-client/types";
import {
  slugifyLeagueName,
  type WatchAddresses,
} from "@softmax/web-features/leagues";
import { curatedThumb } from "@softmax/web-features/replay/art";
import type { PreviewMediaItem } from "../content/preview-details.types";
function leagueCaptureCandidates({
  league,
  addresses,
}: {
  league: LeagueSummary;
  addresses: WatchAddresses;
}): string[] {
  const address = addresses.slugOf(league.id);
  return [
    ...new Set(
      [
        address?.replaceAll("/", "-") ?? null,
        league.short_name ?? null,
        slugifyLeagueName(league.name),
      ].filter((key): key is string => Boolean(key)),
    ),
  ];
}
export function leagueCaptures({
  leagues,
  addresses,
}: {
  leagues: readonly LeagueSummary[];
  addresses: WatchAddresses;
}): PreviewMediaItem[] {
  const captures: PreviewMediaItem[] = [];

  for (const league of leagues) {
    for (const candidate of leagueCaptureCandidates({
      league,
      addresses,
    })) {
      const src = curatedThumb(candidate);

      if (src) {
        captures.push({
          kind: "capture",
          src,
          alt: `${league.name}, mid-episode`,
        });
        break;
      }
    }
  }

  return captures;
}
